/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Free_ToolsInputs */

const en_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tools`)
};

const zh_hans1_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费工具`)
};

const pt_br2_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas grátis`)
};

const es_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas gratis`)
};

const fr_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils gratuits`)
};

const de_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Tools`)
};

const ru_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные инструменты`)
};

const it_footer_free_tools = /** @type {(inputs: Footer_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti gratuiti`)
};

/**
* | output |
* | --- |
* | "Free tools" |
*
* @param {Footer_Free_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_free_tools = /** @type {((inputs?: Footer_Free_ToolsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Free_ToolsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_free_tools(inputs)
	if (locale === "pt-BR") return pt_br2_footer_free_tools(inputs)
	if (locale === "es") return es_footer_free_tools(inputs)
	if (locale === "fr") return fr_footer_free_tools(inputs)
	if (locale === "de") return de_footer_free_tools(inputs)
	if (locale === "ru") return ru_footer_free_tools(inputs)
	if (locale === "it") return it_footer_free_tools(inputs)
	return en_footer_free_tools(inputs)
});